import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, CardBody, Badge } from "reactstrap";
import { Link } from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import api from "./../../../Api.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";

/**
 * RpgLobby — lobby do aluno pra aula ao vivo.
 * Lista as turmas do usuário e mostra quais estão com sessão RPG ativa.
 */
class RpgLobby extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classrooms: [],
      sessions: {}, // { [classroomId]: true|false }
      loading: true
    };
  }

  async componentDidMount() {
    await this.loadClassrooms();
  }

  notify(type, title, message) {
    try {
      this.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: <div className="alert-text"><span className="alert-title">{title}</span><span> {message}</span></div>,
        type: type, icon: 'ni ni-bell-55', autoDismiss: 5
      });
    } catch (e) {}
  }

  async loadClassrooms() {
    try {
      var res = await api.getMyClassRooms();
      var classrooms = Array.isArray(res.data) ? res.data : [];
      this.setState({ classrooms: classrooms, loading: false });
      await this.checkSessions(classrooms);
    } catch (e) {
      this.setState({ loading: false });
      this.notify('danger', 'Ops!', 'Não consegui carregar suas turmas. Tenta de novo em instantes.');
    }
  }

  setSessionStatus(classroomId, active) {
    this.setState(function (prev) {
      var sessions = Object.assign({}, prev.sessions);
      sessions[classroomId] = active;
      return { sessions: sessions };
    });
  }

  async checkSessions(classrooms) {
    var self = this;
    await Promise.all(classrooms.map(async function (classroom) {
      try {
        var res = await api.getActiveSession(classroom.id);
        self.setSessionStatus(classroom.id, !!(res.data && res.data.active));
      } catch (e) {
        // sem sessão / erro pontual: trata como offline, sem quebrar o lobby
        self.setSessionStatus(classroom.id, false);
      }
    }));
  }

  getSortedClassrooms() {
    var sessions = this.state.sessions;
    return this.state.classrooms.slice().sort(function (a, b) {
      var liveA = sessions[a.id] ? 1 : 0;
      var liveB = sessions[b.id] ? 1 : 0;
      return liveB - liveA; // ao vivo primeiro
    });
  }

  render() {
    var sorted = this.getSortedClassrooms();

    return (
      <React.Fragment>
        <style>{'@keyframes rpgLobbyPulse { 0% { box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.6); } 70% { box-shadow: 0 0 0 12px rgba(245, 54, 92, 0); } 100% { box-shadow: 0 0 0 0 rgba(245, 54, 92, 0); } }'}</style>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        {!this.props.embedded && <SimpleHeader name="⚔️ Arena RPG" way={[{ name: "Arena", url: "/live" }]} />}

        <Container className={this.props.embedded ? "mt-3" : "mt--6"} fluid>
          {/* Header explicativo */}
          <Card className="shadow mb-3">
            <CardBody className="text-center">
              <h3 className="mb-1">
                <i className="fas fa-dungeon mr-2 text-primary" />
                Arena RPG
              </h3>
              <p className="mb-0 text-muted">Entre na arena quando seu professor iniciar a sessão RPG! ⚔️🐉</p>
            </CardBody>
          </Card>

          {this.state.loading ? (
            <div className="text-center py-5"><i className="fas fa-spinner fa-spin fa-2x text-muted" /></div>
          ) : sorted.length === 0 ? (
            <Card className="shadow">
              <CardBody className="text-center py-5">
                <i className="fas fa-ghost fa-3x text-muted mb-3" />
                <h4>Você ainda não está em nenhuma turma 👻</h4>
                <p className="text-muted mb-0">Assim que entrar em uma turma, ela aparece aqui pra você batalhar!</p>
              </CardBody>
            </Card>
          ) : (
            <Row>
              {sorted.map((classroom) => {
                var live = !!this.state.sessions[classroom.id];
                return (
                  <Col xs="12" sm="6" md="4" lg="3" key={classroom.id} className="mb-3">
                    <Link to={"/live/" + classroom.id} style={{ textDecoration: 'none' }}>
                      <Card
                        className="shadow h-100"
                        style={{
                          cursor: 'pointer',
                          border: live ? '2px solid #f5365c' : '1px solid #e9ecef',
                          animation: live ? 'rpgLobbyPulse 1.5s infinite' : 'none',
                          transition: 'transform 0.15s ease'
                        }}
                      >
                        <CardBody className="text-center">
                          <div style={{ fontSize: '2rem' }}>{live ? '🐉' : '🏰'}</div>
                          <h5 className="mt-2 mb-2" style={{ color: '#32325d' }}>
                            {classroom.name || ('Turma #' + classroom.id)}
                          </h5>
                          {live ? (
                            <Badge pill style={{ background: '#f5365c', color: '#fff', fontSize: '0.75rem' }}>
                              🔴 AO VIVO
                            </Badge>
                          ) : (
                            <Badge pill color="secondary" style={{ fontSize: '0.75rem' }}>
                              💤 Aguardando professor
                            </Badge>
                          )}
                          <div className="mt-3">
                            <small className="text-muted">
                              {live ? 'A batalha já começou, entre agora!' : 'Fique de olho, a aventura pode começar a qualquer momento...'}
                            </small>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          )}
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({ user: state.user }))(RpgLobby);
